import { render, staticRenderFns } from "./AddMemberModal.vue?vue&type=template&id=2cb1f1ef"
import script from "./AddMemberModal.vue?vue&type=script&lang=js"
export * from "./AddMemberModal.vue?vue&type=script&lang=js"
import style0 from "./AddMemberModal.vue?vue&type=style&index=0&id=2cb1f1ef&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports